import api from "@apiClient";
import useTable from "@hooks/useTable";
import React, { useState } from "react";
import Table from "@components/admin/Table";
import MyAvatar from "@components/admin/MyAvatar";
import PageNavigator from "@components/admin/PageNavigator";
import ReportFilter from "@components/admin/ReportFilter";
import { ReportFilters } from "@helpers";
import PopperList from "@components/admin/PopperList";
import PopperWrapper from "@components/admin/PopperWrapper";
import { CircularProgress, IconButton } from "@mui/material";
import Button from "./Button";

import { MoreHoriz } from "@mui/icons-material";
import clsx from "clsx";
import useReportActions from "@hooks/useReportActions";
import UserReportDetail from "@components/admin/ReportDetails/UserReportDetail";
import BanUserDetails from "../BanUserDetails";
export default function UserReports() {
  const [activeReportFilter, setActiveReportFilter] = useState(
    ReportFilters.UNRESOLVED
  );
  const [selectedUserReport, setSelectedUserReport] = useState(null);
  const [userToBan, setUserToBan] = useState();

  const handleCloseUserBanDetailsModel = () => {
    setUserToBan();
  }

  const {
    setPage,
    page,
    totalPages,
    count,
    data,
    checked,
    setChecked,
    setLimit,
    limit,
    setSortColumns,
    sortColumns,
    loading,
    setReload,
    setFilters,
  } = useTable({
    getData: api.getUserReports,
    pageSize: 10,
    initialFilters: {
      status: activeReportFilter,
    },
  });

  const { actionButtons, selectedActionButtons, getActionLinks, warningModal } =
    useReportActions({
      reloadPage: () => setReload((reload) => reload + 1),
      hideModal: () => setSelectedUserReport(null),
      getUserFromReport: (report) => report.userReported,
      onLinkClick: () => setPage(1),
      selectedReport: selectedUserReport,
      checked,
      data,
      activeReportFilter,
      extraReportModalActions: [
        {
          label: "Ban User Globally",
          color: 'error',
          onClick: () => {
            setSelectedUserReport(null);
            setUserToBan(selectedUserReport?.userReported);
          },
        },
      ],
    });

  const fields = [
    {
      columnName: "Name",
      render: (item) => (
        <MyAvatar
          src={item.userReported?.media?.currBucketUrl}
          name={
            item.userReported?.firstName + " " + item.userReported?.lastName
          }
        />
      ),
    },
    {
      columnName: "username",
      render: (item) => item.userReported?.userName,
    },
    {
      columnName: "Email",
      render: (item) => item.userReported?.emailAddress,
    },
    {
      columnName: "Reporter",
      render: (item) =>
        item.reportedBy?.emailAddress,
    },
    {
      columnName: "Description",
      field: "reason",
      render: (item) => item.reason,
    },
    {
      columnName: "Status",
      field: "status",
      render: (item) => item.status,
    },
    {
      columnName: "Date",
      field: "createdAt",
      render: (item) => new Date(item.createdAt).toLocaleDateString(),
    },
    {
      columnName: "Actions",
      render: (item) => (
        <PopperWrapper id={item.id}>
          <IconButton>
            <MoreHoriz />
          </IconButton>
          <PopperList
            items={[
              {
                label: "View Details",
                onClick: () => setSelectedUserReport(item),
              },
              {
                label: "Ban User Globally",
                onClick: () => setUserToBan(item.userReported),
              },
              ...getActionLinks(item),
            ]}
          />
        </PopperWrapper>
      ),
    },
  ];

  const reportFilterButtons = Object.values(ReportFilters).map((filter) => {
    return {
      label: filter,
      onClick: () => {
        setActiveReportFilter(filter);
        setFilters({ status: filter });
      },
    };
  });

  if (loading) return <CircularProgress />;
  return (
    <div>
      <div className="flex items-center gap-2">
        <ReportFilter
          count={count}
          activeReportFilter={activeReportFilter}
          reportFilterButtons={reportFilterButtons}
        />
        <div
          className={clsx(
            Object.values(checked).filter((val) => val).length === 0 &&
              "hidden",
            "ml-auto flex items-center gap-2"
          )}
        >
          {selectedActionButtons.map((button, index) => (
            <Button variant="contained" key={index} {...button} />
          ))}
        </div>
      </div>
      <Table
        data={data}
        fields={fields}
        checked={checked}
        setChecked={setChecked}
        setSortColumns={setSortColumns}
        sortColumns={sortColumns}
      />
      {data.length > 0 && (
        <PageNavigator
          totalPages={totalPages}
          setPage={setPage}
          page={page}
          setLimit={setLimit}
          limit={limit}
        />
      )}
      {selectedUserReport && (
        <UserReportDetail
          userReport={selectedUserReport}
          setUserReport={setSelectedUserReport}
          actionButtons={actionButtons}
        />
      )}
      {warningModal()}

      <BanUserDetails
        user={userToBan}
        open={Boolean(userToBan)}
        onClose={handleCloseUserBanDetailsModel}
        onSuccess={() => {
          handleCloseUserBanDetailsModel();
          setReload(r => r + 1);
        }}
      />
    </div>
  );
}
